var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5001,
    cy: 12.4999,
    r: 10.7143,
    fill: "#FFCA23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6072 5.08231C11.6072 4.5892 12.0069 4.18945 12.5 4.18945C17.0898 4.18945 20.8105 7.91016 20.8105 12.4999C20.8105 17.0896 17.0898 20.8103 12.5 20.8103C12.0069 20.8103 11.6072 20.4106 11.6072 19.9175C11.6072 19.4244 12.0069 19.0246 12.5 19.0246C16.1035 19.0246 19.0248 16.1034 19.0248 12.4999C19.0248 8.89639 16.1035 5.97517 12.5 5.97517C12.0069 5.97517 11.6072 5.57542 11.6072 5.08231Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin-icon.9e2bf52e7e03160367bbe995f4d97977.svg";
export { ForwardRef as ReactComponent };